import { defineMessages } from "react-intl"

export const VALIDATION_MESSAGES = defineMessages({
  required: {
    id: "Form.field.required",
    description: "Form required field message",
    defaultMessage: "This field is required"
  },
  batch: {
    id: "Form.field.batch",
    description: "Form batch validation message",
    defaultMessage:
      "Please indicate a valid batch number: PT, CR, or ED followed by 6 digits, or OP followed by 5 digits"
  },
  fileSize: {
    id: "Form.field.fileSize",
    description: "Form file size error message",
    defaultMessage: "The file is too large, 200MB max file size"
  },
  fileType: {
    id: "Form.field.fileType",
    description: "Form file type error message",
    defaultMessage: "We only support .zip"
  },
  minLength: {
    id: "Form.field.minLength",
    description: "Form min length error message",
    defaultMessage: "This field must be at least {min} characters"
  },
  maxLength: {
    id: "Form.field.maxLength",
    description: "Form max length error message",
    defaultMessage: "This field must be max {max} characters"
  }
})
